module.exports = __webpack_public_path__ + "img/icons BFr_27.ca9e0df7.png";